import type {ChipPropsVariantOverrides} from '@mui/material/Chip/Chip';
import type {OverridableStringUnion} from '@mui/types';
import type {STATUS} from '@/domain/entities/ForestMassStatus';

export const APP_NAME = 'cubia';
export const API_URL = window.APP_CONFIG?.API_BASE_URL;
export const APP_HASH = __APP_HASH__;
export const APP_VERSION = __APP_VERSION__;
export const APP_TIMESTAMP = __APP_TIMESTAMP__;

export const INITIAL_VIEWPORT = {
  latitude: 42.74,
  longitude: -8,
  zoom: 7,
  bearing: 0,
  pitch: 0,
};

export const MAPSTYLES = [
  {
    label: 'PNOA',
    thumbnail: '/mapStyles/pnoa.png',
    id: '/mapStyles/pnoa.json',
  },
];

export const INITIAL_MAPSTYLE_URL = MAPSTYLES[0].id;

export const COUNCILS = [
  'Abadín',
  'Abegondo',
  'Agolada',
  'Alfoz',
  'Allariz',
  'Ames',
  'Amoeiro',
  'Antas de Ulla',
  'Aranga',
  'Arbo',
  'Ares',
  'Arnoia, A',
  'Arteixo',
  'Arzúa',
  'Avión',
  'Baiona',
  'Baleira',
  'Baltar',
  'Bande',
  'Baralla',
  'Barbadás',
  'Barco de Valdeorras, O',
  'Barreiros',
  'Barro',
  'Baños de Molgas',
  'Beariz',
  'Becerreá',
  'Begonte',
  'Beade',
  'Bergondo',
  'Betanzos',
  'Blancos, Os',
  'Boborás',
  'Boimorto',
  'Boiro',
  'Bola, A',
  'Bolo, O',
  'Boqueixón',
  'Bóveda',
  'Brión',
  'Bueu',
  'Burela',
  'Cabana de Bergantiños',
  'Cabanas',
  'Caldas de Reis',
  'Calvos de Randín',
  'Cambados',
  'Cambre',
  'Camariñas',
  'Campo Lameiro',
  'Cangas',
  'Capela, A',
  'Carballiño, O',
  'Carballeda de Avia',
  'Carballeda de Valdeorras',
  'Carballedo',
  'Carballo',
  'Cariño',
  'Carnota',
  'Carral',
  'Cartelle',
  'Castrelo de Miño',
  'Castrelo do Val',
  'Castro Caldelas',
  'Castro de Rei',
  'Castroverde',
  'Catoira',
  'Cañiza, A',
  'Cedeira',
  'Cee',
  'Celanova',
  'Cenlle',
  'Cerceda',
  'Cerdedo-Cotobade',
  'Cerdido',
  'Cervantes',
  'Cervo',
  'Chandrexa de Queixa',
  'Chantada',
  'Coirós',
  'Coles',
  'Corcubión',
  'Corgo, O',
  'Coristanco',
  'Cortegada',
  'Coruña, A',
  'Cospeito',
  'Covelo',
  'Crecente',
  'Cualedro',
  'Culleredo',
  'Cuntis',
  'Curtis',
  'Dozón',
  'Dodro',
  'Dumbría',
  'Entrimo',
  'Esgos',
  'Estrada, A',
  'Ferrol',
  'Fene',
  'Fisterra',
  'Folgoso do Courel',
  'Fonsagrada, A',
  'Forcarei',
  'Fornelos de Montes',
  'Foz',
  'Frades',
  'Friol',
  'Gomesende',
  'Gondomar',
  'Grove, O',
  'Guarda, A',
  'Gudiña, A',
  'Guitiriz',
  'Guntín',
  'Illa de Arousa, A',
  'Incio, O',
  'Irixo, O',
  'Irixoa',
  'Lalín',
  'Lama, A',
  'Láncara',
  'Laracha, A',
  'Larouco',
  'Laxe',
  'Laza',
  'Leiro',
  'Lobeira',
  'Lobios',
  'Lugo',
  'Lourenzá',
  'Lousame',
  'Maceda',
  'Malpica de Bergantiños',
  'Manzaneda',
  'Marín',
  'Maside',
  'Mazaricos',
  'Meaño',
  'Meira',
  'Meis',
  'Melide',
  'Melón',
  'Merca, A',
  'Mesía',
  'Mezquita, A',
  'Miño',
  'Moeche',
  'Moaña',
  'Mondariz',
  'Mondariz-Balneario',
  'Mondoñedo',
  'Monfero',
  'Monforte de Lemos',
  'Montederramo',
  'Monterrei',
  'Monterroso',
  'Moraña',
  'Mos',
  'Muíños',
  'Mugardos',
  'Muros',
  'Muxía',
  'Muras',
  'Narón',
  'Navia de Suarna',
  'Neda',
  'Negreira',
  'Negueira de Muñiz',
  'Neves, As',
  'Nigrán',
  'Noia',
  'Nogais, As',
  'Nogueira de Ramuín',
  'Oia',
  'Oímbra',
  'Oleiros',
  'Ordes',
  'Oroso',
  'Ortigueira',
  'Ourense',
  'Outeiro de Rei',
  'Outes',
  'Ourol',
  'Oza-Cesuras',
  'Paderne',
  'Paderne de Allariz',
  'Padrenda',
  'Padrón',
  'Palas de Rei',
  'Pantón',
  'Parada de Sil',
  'Paradela',
  'Pastoriza, A',
  'Pazos de Borbén',
  'Pedrafita do Cebreiro',
  'Pereiro de Aguiar, O',
  'Peroxa, A',
  'Petín',
  'Piñor',
  'Pino, O',
  'Poio',
  'Pol',
  'Pontedeume',
  'Pontedeva',
  'Ponteareas',
  'Ponte Caldelas',
  'Ponteceso',
  'Pontecesures',
  'Pontevedra',
  'Pontenova, A',
  'Pontes de García Rodríguez, As',
  'Porriño, O',
  'Portas',
  'Porto do Son',
  'Portomarín',
  'Pobra de Trives, A',
  'Pobra do Brollón, A',
  'Pobra do Caramiñal, A',
  'Porqueira',
  'Páramo, O',
  'Punxín',
  'Quiroga',
  'Quintela de Leirado',
  'Rairiz de Veiga',
  'Ramirás',
  'Rábade',
  'Redondela',
  'Rianxo',
  'Ribadavia',
  'Ribadeo',
  'Ribadumia',
  'Ribas de Sil',
  'Ribeira',
  'Ribeira de Piquín',
  'Ribadumia',
  'Riós',
  'Riotorto',
  'Rodeiro',
  'Rois',
  'Rosal, O',
  'Rubiá',
  'Rúa, A',
  'Sada',
  'Salceda de Caselas',
  'Salvaterra de Miño',
  'Samos',
  'San Amaro',
  'San Cibrao das Viñas',
  'San Cristovo de Cea',
  'San Sadurniño',
  'San Xoán de Río',
  'Sandiás',
  'Santa Comba',
  'Santiago de Compostela',
  'Santiso',
  'Sarreaus',
  'Sarria',
  'Saviñao, O',
  'Silleda',
  'Sobrado',
  'Sober',
  'Somozas, As',
  'Soutomaior',
  'Taboada',
  'Taboadela',
  'Teixeira, A',
  'Teo',
  'Toén',
  'Toques',
  'Tordoia',
  'Tomiño',
  'Touro',
  'Trabada',
  'Trasmiras',
  'Trazo',
  'Triacastela',
  'Tui',
  'Valadouro, O',
  'Val do Dubra',
  'Valdoviño',
  'Valga',
  'Vedra',
  'Veiga, A',
  'Verea',
  'Verín',
  'Viana do Bolo',
  'Vicedo, O',
  'Vigo',
  'Vilaboa',
  'Vila de Cruces',
  'Vilagarcía de Arousa',
  'Vilalba',
  'Vilamarín',
  'Vilamartín de Valdeorras',
  'Vilanova de Arousa',
  'Vilardevós',
  'Vilariño de Conso',
  'Vilasantar',
  'Vilar de Barrio',
  'Vilar de Santos',
  'Vilarmaior',
  'Viveiro',
  'Vimianzo',
  'Xermade',
  'Xinzo de Limia',
  'Xove',
  'Xunqueira de Ambía',
  'Xunqueira de Espadanedo',
  'Zas',
];

type STATUS_VALUES = {
  color: string;
  bgcolor: string;
  variant: OverridableStringUnion<'filled' | 'outlined', ChipPropsVariantOverrides>;
};

export const DEFAULT_STATUS_PROPS: STATUS_VALUES = {
  color: 'grey.700',
  bgcolor: 'grey.300',
  variant: 'outlined',
};

export const STATUS_PROPS: Record<STATUS, STATUS_VALUES> = {
  FOREST_MASS_CREATED: {
    color: '#247a44',
    bgcolor: '#93f501',
    variant: 'filled',
  },
  CUT_FORCED: {
    color: '#680404',
    bgcolor: '#e46060',
    variant: 'filled',
  },
  PENDING_PLOT_INVENTORIES: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'outlined',
  },
  PENDING_UAV_FLIGHT: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'filled',
  },
  PENDING_PLOT_INVENTORY_APPRAISER: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'filled',
  },
  CUT_PENDING: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'filled',
  },
  WEIGHT_PENDING: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'filled',
  },
  CUT_WEIGHTED: {
    color: '#247a44',
    bgcolor: '#93f501',
    variant: 'filled',
  },
  PENDING_INVENTORY_PLOTS: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'outlined',
  },
  PENDING_SLAM: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'filled',
  },
  INVENTORY_PLOTS_COMPLETED: {
    color: '#247a44',
    bgcolor: '#93f501',
    variant: 'filled',
  },
  UAV_FLIGHT_DONE: {
    color: '#247a44',
    bgcolor: '#93f501',
    variant: 'filled',
  },
  METRICS_PROCESSING: {
    color: '#832a07',
    bgcolor: '#d9a052',
    variant: 'filled',
  },
  METRICS_SUCCESSFUL: {
    color: '#247a44',
    bgcolor: '#93f501',
    variant: 'filled',
  },
  METRICS_FAILED: {
    color: '#680404',
    bgcolor: '#e46060',
    variant: 'filled',
  },
};

export const VIEW_TYPE_ID = {
  TABLE: 'table',
  MAP: 'map',
};
